var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#474F54",
    d: "M64 0v41.25l-3.75 3.875H3.75L0 41.25V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32393F",
    d: "M64 0v41.25l-3.75 3.875H32V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADAE5",
    d: "M22.625 50.875h18.75v11.25h-18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9D3",
    d: "M32 50.875h9.375v11.25H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M0 41.25h64v11.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADAE5",
    d: "M32 41.25h32v11.5H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M15.125 60.25h33.75V64h-33.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADAE5",
    d: "M32 60.25h16.875V64H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#549EF2",
    d: "M20.75 7.5c-7.236 0-13.125 5.889-13.125 13.125S13.514 33.75 20.75 33.75s13.125-5.889 13.125-13.125S27.986 7.5 20.75 7.5zm0 18.75a5.631 5.631 0 01-5.625-5.625A5.631 5.631 0 0120.75 15a5.631 5.631 0 015.625 5.625 5.631 5.631 0 01-5.625 5.625z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#377FD2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.125 7.5H56.5v3.75H45.125zM37.625 7.5h3.75v3.75h-3.75zM45.125 22.5H56.5v3.75H45.125zM37.625 22.5h3.75v3.75h-3.75zM37.625 15H56.5v3.75H37.625zM37.625 30H56.5v3.75H37.625z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculator);
export default __webpack_public_path__ + "static/media/icon-calculator.21bc9adc97d084a64aedb386f1e35c0d.svg";
export { ForwardRef as ReactComponent };